module.exports = __webpack_public_path__ + "static/media/transportation-hospitality-landscape.b42c2326.jpg";